import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../lib/domain';
import ErrorWrapper from '../../lib/error_wrapper';
import { showErrorInNotification, formatMoney } from '../../lib/util';
import { Spin, Table, Row, Input, Button } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { BasicHeader } from '../../components/basic_header';
import { recon_quick_menu } from '../../util/ui_util';


const datatype_overview_cols=()=>[
  {
    title:"Datatype",
    dataIndex:'data_type_name',
    render:(name,data)=>{
      return <Link to={`/activity/data-type/${data.data_type_id}/transactions`}>{name}</Link>
      }
  },
  {
    title:"Total Count",
    dataIndex:'count',
    className:'right-align',
    render:(count,data)=>{
    return <Link to={`/activity/data-type/${data.data_type_id}/transactions`}>{formatMoney(count,0)}</Link>
    }
  },
  {
    title:"Total Amount",
    dataIndex:'amount',
    className:'right-align',
    render:(amount,data)=>{
      return <Link to={`/activity/data-type/${data.data_type_id}/transactions`}>
        {formatMoney(amount)}
        </Link>
      }
  },
  {
    title:"This week",
    dataIndex:'week_fetch_count',
    className:'right-align',
    render:(count,data)=>{
      return <Link to={{
          pathname:`/activity/data-type/${data.data_type_id}/transactions`,
          search:`dateFrom=${moment().startOf('week').format('YYYY-MM-DD')}&dateTo=${moment().endOf('week').format('YYYY-MM-DD')}`
      }}
      >{formatMoney(count,0)}</Link>
      }
    
  },
  {
    title:"This month",
    dataIndex:'month_fetch_count',
    className:'right-align',
    render:(count,data)=>{
      return <Link to={{
          pathname:`/activity/data-type/${data.data_type_id}/transactions`,
          search:`dateFrom=${moment().startOf('month').format('YYYY-MM-DD')}&dateTo=${moment().endOf('month').format('YYYY-MM-DD')}`
      }}
      >{formatMoney(count,0)}</Link>
      }
  }

]
const service_overview_cols=()=>[
  {
    title:"Service",
    dataIndex:'service_name',
    render:(name,data)=>{
      return <Link to={{
          pathname:`/activity/data-type/${data.data_type_id}/transactions`,
          search:`service=${data.data_service_id||'unclassified'}`
      }}>{name}</Link>
      }
  },
  {
    title:"Total Count",
    dataIndex:'count',
    className:'right-align',
    render:(count,data)=>{
    return <Link to={{
      pathname:`/activity/data-type/${data.data_type_id}/transactions`,
      search:`service=${data.data_service_id||'unclassified'}`
      }}>{formatMoney(count,0)}</Link>
    }
  },
  {
    title:"Total Amount",
    dataIndex:'amount',
    className:'right-align',
    render:(amount,data)=>{
      return <Link to={{
        pathname:`/activity/data-type/${data.data_type_id}/transactions`,
        search:`service=${data.data_service_id||'unclassified'}`
    }}>{formatMoney(amount)}</Link>
      }
  },
  // {
  //   title:"This week",
  //   dataIndex:'week_fetch_count',
  //   render:(count,data)=>{
  //     return <Link to={{
  //         pathname:`/recon/data-type/${data.data_type_id}`,
  //         search:`service=${data.data_service_id}&&dateFrom=${moment().startOf('week').format('YYYY-MM-DD')}&dateTo=${moment().endOf('week').format('YYYY-MM-DD')}`
  //     }}
  //     >{count}</Link>
  //     }
    
  // },
  // {
  //   title:"This month",
  //   dataIndex:'month_fetch_count',
  //   render:(count,data)=>{
  //     return <Link to={{
  //         pathname:`/recon/data-type/${data.data_type_id}`,
  //         search:`dateFrom=${moment().startOf('month').format('YYYY-MM-DD')}&dateTo=${moment().endOf('month').format('YYYY-MM-DD')}`
  //     }}
  //     >{count}</Link>
  //     }
  // }

]
class AllDataOverview extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       
    }
    this.get_overview=RESTExecutor.detail().config({
      label:'overview'
    }).callbacks((success)=>{

    },(error)=>{
      showErrorInNotification(error);

    }).connect(props.domains.allData);
    this.get_overview.execute()
  }
  
  render() {
    let get_overview_resp=this.get_overview.response();
    let rowsData=(get_overview_resp.result&&get_overview_resp.result.rows)||[];

    let filteredData=JSON.parse(JSON.stringify(rowsData));
    if(this.state.query){
      filteredData=filteredData.filter(({ data_type_name="",id="",description="" }) => {
        data_type_name = data_type_name.toLowerCase();
          id=id.toLowerCase();
          description=description.toLowerCase();
          return data_type_name.includes(this.state.query.toLowerCase())
          ||id.includes(this.state.query.toLowerCase())
          ||description.includes(this.state.query.toLowerCase())
          ;
      });
  }

    return (
      <div>
      <BasicHeader no_back title="Datatype Overview"
                 menu_items={recon_quick_menu}

      />
      <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
                       <Input.Search
                            placeholder="Search For"
                            style={{
                        }}
                        allowClear
                        autoFocus
                            value={this.state.query}
                            onChange={(e) => {
                                this.setState({query:e.target.value})
                            }}
                            />
      </div></div>

      <ErrorWrapper
      error={get_overview_resp}
      onReload={()=>{
        this.get_overview.execute();
      }}
      >
        <div className='default-card' style={{
          padding:0
        }}>
        <Table
        scroll={{x:true}}
        loading={get_overview_resp.fetching}
                    columns={datatype_overview_cols({
                    })}
                    dataSource={filteredData}
                    className='main-table'
                    size='small'
                    expandedRowRender={(record,index,indent,expanded)=>{
                      if(expanded){
                        return <ServiceOverview key={record.data_type_id} datatype={record.data_type_id}/>
                      }else {
                        return null
                      }
                    }}
                    pagination={filteredData.length>10}
                    rowKey={(record) => record.data_type_id}
                />
        
        </div>
      </ErrorWrapper>
      </div>
    );
  }
  componentDidMount(){
    try{
      window.header_assigner.assignTitle("Datatype Overview");

  }catch(e){}
  }
}

export default withDomains(AllDataOverview,"allData");


class _ServiceOverview extends Component{
  constructor(props) {
    super(props)
  
    this.state = {
       
    }
    this.get_overview=RESTExecutor.detail().config({
      label:'service_overview'
    }).callbacks((success)=>{

    },(error)=>{
      showErrorInNotification(error);

    }).connect(props.domains.allData);
    this.get_overview.forId(this.props.datatype).execute()
  }
  render(){
    let get_overview_resp=this.get_overview.response();
    let rowsData=(get_overview_resp.result&&get_overview_resp.result.rows)||[];

    let filteredData=JSON.parse(JSON.stringify(rowsData));
    if(this.state.query){
      filteredData=filteredData.filter(({ service_name="",id="",description="" }) => {
        service_name = service_name.toLowerCase();
          id=id.toLowerCase();
          description=description.toLowerCase();
          return service_name.includes(this.state.query.toLowerCase())
          ||id.includes(this.state.query.toLowerCase())
          ||description.includes(this.state.query.toLowerCase())
          ;
      });
  }
  return (
    <ErrorWrapper
    error={get_overview_resp}
    onReload={()=>{
      this.get_overview.execute();
    }}
    >
      <div className='default-card' style={{
        padding:0
      }}>
      <Table
      scroll={{x:true}}
      loading={get_overview_resp.fetching}
                  columns={service_overview_cols({
                  })}
                  dataSource={filteredData}
                  className='main-table'
                  size='small'
                  pagination={filteredData.length>10}
              //     title={() => <div><Row type='flex' justify='space-between' style={{
              //         alignItems: 'center'
              //     }}><Title
              //         level={3}
              //         style={{
              //             margin: 0
              //         }}>Services Overview</Title>
              //     </Row>
              //     <Row type='flex'
              //     justify='space-between'
              //     style={{
              //     alignItems: 'center',
              //     flexWrap: 'nowrap'
              // }}>
              //         <Input.Search
              //             placeholder="Search For"
              //             style={{
              //         }}
              //             value={this.state.query}
              //             onChange={(e) => {
              //                 this.setState({query:e.target.value})
              //             }}
              //             /> {this.state.query && this.state.query.length > 0 && <Button
              //             style={{
              //             marginLeft: 4
              //         }}
              //             type='danger'
              //             shape="circle"
              //             icon="close-circle"
              //             onClick={() => {
              //             this.setState({query:null})
              //         }}/>}
              //     </Row>
              //     </div>}
                  
                  rowKey={(record) => record.data_service_id}
              />
      
      </div>
    </ErrorWrapper>
  );
  }

  
}

const ServiceOverview = withDomains(_ServiceOverview,"allData");